import { SxProps, Theme } from '@mui/material';

export interface AvatarAccent {
  background: string;
  color: string;
  ring: string;
}

const AVATAR_ACCENTS: AvatarAccent[] = [
  { background: 'linear-gradient(145deg, #0ea5e9 0%, #0369a1 100%)', color: '#f0f9ff', ring: '#38bdf8' },
  { background: 'linear-gradient(145deg, #14b8a6 0%, #0f766e 100%)', color: '#f0fdfa', ring: '#2dd4bf' },
  { background: 'linear-gradient(145deg, #8b5cf6 0%, #6d28d9 100%)', color: '#f5f3ff', ring: '#a78bfa' },
  { background: 'linear-gradient(145deg, #f59e0b 0%, #b45309 100%)', color: '#fffbeb', ring: '#fbbf24' },
  { background: 'linear-gradient(145deg, #f472b6 0%, #db2777 100%)', color: '#fdf2f8', ring: '#f9a8d4' },
  { background: 'linear-gradient(145deg, #34d399 0%, #059669 100%)', color: '#ecfdf5', ring: '#6ee7b7' },
];

/** Dark page backdrop — ring matches tournament public page cards. */
export const AVATAR_STACK_CUTOUT = '#0c1222';

export function avatarAccentFromName(name?: string | null, slotIndex = 0): AvatarAccent {
  const label = (name || '').trim().toLowerCase();
  let hash = slotIndex * 7;
  for (let i = 0; i < label.length; i += 1) {
    hash = (hash + label.charCodeAt(i) * (i + 3)) % 997;
  }
  return AVATAR_ACCENTS[hash % AVATAR_ACCENTS.length];
}

export function avatarInitials(name?: string | null): string {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
  }
  const single = parts[0] || '?';
  return single.slice(0, 2).toUpperCase();
}

export function playerAvatarSx(
  name: string | null | undefined,
  size: number,
  hasPhoto: boolean,
  slotIndex = 0
): SxProps<Theme> {
  const accent = avatarAccentFromName(name, slotIndex);
  return {
    width: size,
    height: size,
    fontSize: size <= 28 ? '0.65rem' : '0.72rem',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: accent.color,
    background: hasPhoto ? 'rgba(255,255,255,0.08)' : accent.background,
    boxShadow: `0 0 0 2px ${AVATAR_STACK_CUTOUT}, 0 0 0 3px ${accent.ring}55, 0 2px 8px rgba(0,0,0,0.35)`,
    border: 'none',
  };
}

export function teamAvatarStackWidth(size: number, overlap = 0.55): number {
  return Math.round(size + size * overlap);
}
